"use strict";

module.exports = ['$resource', function ( $resource ) {

	let Token = $resource('/tokens/:id',
		{
			id: '@id'
		},
		{
			'save': {method:'POST'},
			'update': {method: 'PATCH'}
		}
	);

	var save = Token.save;

	// Required for "easy" .save in controllers
	Token.save = function ( ...args ) {

		if( args[0].id ) {
			this.update.apply(this, args);
		} else {
			save.apply(this, args);
		}
	};

	return Token;
}];
